<template>
    <div class="text-center">
        <span
            class="badge font-monospace border"
            :style="{
                'background-color': normalizedValue,
                color: getContrastColor(normalizedValue),
            }"
            >{{ normalizedValue }}</span
        >
    </div>
</template>

<script setup lang="ts">
import { $ti } from '@/locize';
import { computed } from 'vue';

const props = defineProps<{
    /**
     * The distance to display
     * This is the distance in meters
     */
    value: string | null;
}>();

const normalizedValue = computed(() => {
    if (props.value === null) {
        return '';
    }
    let value: string = props.value?.toLowerCase();
    if (!value.startsWith('#')) {
        value = '#' + value;
    }

    return value;
});

const getContrastColor = (hexcolor: string): string => {
    if (hexcolor === null) {
        return '';
    }
    let r = parseInt(hexcolor.substring(1, 2), 16);
    let g = parseInt(hexcolor.substring(3, 2), 16);
    let b = parseInt(hexcolor.substring(5, 2), 16);
    let yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? 'black' : 'white';
};

/**
 * Format the distance to a human readable string
 * @param distance
 */
</script>
